import React, { useEffect } from 'react'
import './MainHome.css'

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Sofacleaningimg from '../../Images/HomeImages/ProsonImg2.jpg'
import FullHomeCleaningimg from '../../Images/HomeImages/Personimghome.jpg'
import KitchenImg from '../../Images/HomeImages/KitchenImg.jpg'
import WomenCleaningimg from '../../Images/HomeImages/HomeAboutimg.png'
import WomenCleaningimg1 from '../../Images/HomeImages/Cleaningimg2.jpg'
import HowItWorks from '../../Components/HowitsWork/Howitswork';
import Homecleaning from '../../Images/HomeImages/house-cleaning.png'
import CommercialCleaning from '../../Images/HomeImages/office-cleaning.png'
import Bathroomcleaning from '../../Images/HomeImages/BathroomCleaning.jpg'
import PricingComponent from '../../Components/PricingCard/Pricingcard';
import CallBack from '../../Components/CallBack/CallBack';
import MainHomeContainer from '../../Components/MainHomeContainer/MainHomeContainer';
import Footer from '../../Components/Footer/Footer';
import NewHomeNav from '../../Components/Navbar/NewNavbar';
import AOS from 'aos';
import 'aos/dist/aos.css';
function MainHome() {
    useEffect(() => {
        AOS.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
    }, []);
    return (
        <>
            <NewHomeNav />
            <MainHomeContainer />
            <div className="MainHome-services-container" id='MainHome-services-container' >
                <div className="MainHome-services-container-subcontainer1">
                    <div className="MainHome-services-container-subcontainer1-title" style={{ color: '#384D64', fontWeight: '600' }}>OUR SERVICES</div>
                    <h2 className='how-it-works-title'>Most Popular Services</h2>
                    <div className="MainHome-services-container-subcontainer1-title-content-des" style={{ textAlign: 'center' }}>Explore our top services designed for you! Quality and care await.</div>
                </div>
                <div className="MainHome-services-container-subcontainer2">
                    <div className="MainHome-services-container-subcontainer2-services-container">
                        <div className="service-img">
                            <img src={FullHomeCleaningimg} alt="" />
                        </div>
                        <div className="service-content-title">Full Home Cleaning</div>
                        <div className="service-content-descreption">Astraclean offers expert, eco-friendly full home cleaning for a spotless, fresh space.</div>
                        <Link to='/home-cleaning'><div className="service-btn">  <FontAwesomeIcon icon={faChevronRight} /></div></Link>
                    </div>
                    <div className="MainHome-services-container-subcontainer2-services-container">
                        <div className="service-img">
                            <img src={Sofacleaningimg} alt="" />
                        </div>
                        <div className="service-content-title">Sofa Cleaning</div>
                        <div className="service-content-descreption">Astraclean restores sofas, removing stains and dirt for a fresh, clean look.</div>
                        <Link to='/sofa-cleaning'>
                            <div className="service-btn">  <FontAwesomeIcon icon={faChevronRight} /></div>

                        </Link>
                    </div>
                    <div className="MainHome-services-container-subcontainer2-services-container">
                        <div className="service-img">
                            <img src={Bathroomcleaning} alt="" />
                        </div>
                        <div className="service-content-title">Bathroom Cleaning</div>
                        <div className="service-content-descreption">Expert bathroom cleaning by Astraclean, ensuring sanitized, sparkling surfaces and fixtures</div>
                        <Link to='/bathroom-cleaning'>
                            <div className="service-btn">  <FontAwesomeIcon icon={faChevronRight} /></div>
                        </Link>
                    </div>
                    <div className="MainHome-services-container-subcontainer2-services-container diffrent-box" >
                        <div className="service-img">
                            <img src={KitchenImg} alt="" />
                        </div>
                        <div className="service-content-title">Kitchen Cleaning</div>
                        <div className="service-content-descreption" >Astraclean deep cleans kitchens, tackling grease, grime, and stains for hygienic results.</div>
                        <Link to='/Kitchen-cleaning'>
                            <div className="service-btn">  <FontAwesomeIcon icon={faChevronRight} /></div>
                        </Link>
                    </div>
                </div>
                {/* <div className="MainHome-services-container-subcontainer3">More Services</div> */}
            </div>
            <div className="MainHome-aboutus-container">
                <div className="MainHome-aboutus-container-sub1">
                    <div className="MainHome-aboutus-container-sub1-box1">
                        <img src={WomenCleaningimg1} alt="" />
                    </div>
                    <div className="MainHome-aboutus-container-sub1-box2">
                        <div className="MainHome-aboutus-container-sub1-box2-circle">
                            <span style={{ fontSize: "2rem", fontWeight: '700' }}>
                                5+
                            </span>
                            <span style={{ textAlign: 'center', padding: '10px' }}>Year of <br /> Experience</span>
                        </div>
                        <div className="MainHome-aboutus-container-sub1-box2-ellipse-img">
                            <img src={WomenCleaningimg} alt="" />
                        </div>
                    </div>
                </div>
                <div className="MainHome-aboutus-container-sub2">
                    <span style={{ color: '#384D64', fontWeight: '600' }}>ABOUT US</span>
                    <h2 className="how-it-works-title" >Reliable,Affordable & Eco Friendly Company</h2>
                    <div className="MainHome-aboutus-container-sub2-box2">Our company provides top-quality, affordable services with a strong commitment to eco-friendly practices. We deliver reliable solutions that meet your needs while ensuring efficiency, cost-effectiveness, and minimal environmental impact.</div>
                    <div className="MainHome-aboutus-container-sub2-box3">
                        <div className="MainHome-aboutus-container-sub2-box3-ellipse">
                            <div className="MainHome-aboutus-container-sub2-box3-ellipse-circle-icon">
                                <img src={Homecleaning} alt="" />
                            </div>
                            <div className="MainHome-aboutus-container-sub2-box3-ellipse-discreption">
                                <span style={{ fontWeight: '600', marginBottom: '10px' }}>Full Home Cleaning</span>
                                <span style={{ fontSize: '0.8rem' }}>Comprehensive cleaning for your home, making every space spotless and hygienic.</span>
                            </div>
                        </div>
                        <div className="MainHome-aboutus-container-sub2-box3-ellipse">
                            <div className="MainHome-aboutus-container-sub2-box3-ellipse-circle-icon">
                                <img src={CommercialCleaning} alt="" />
                            </div>
                            <div className="MainHome-aboutus-container-sub2-box3-ellipse-discreption">
                                <span style={{ fontWeight: '600', marginBottom: '10px' }}>Commercial Cleaning</span>
                                <span style={{ fontSize: '0.8rem' }}>Expert cleaning for businesses, ensuring a clean and productive workplace environment.</span>
                            </div>
                        </div>
                    </div>
                    <Link to='/about' style={{ textDecoration: 'none' }}><div className="MainHome-services-container-subcontainer3">More About Us</div></Link>
                </div>
            </div>
            <HowItWorks />
            <CallBack />
            <div className="MainHome-services-container-subcontainer1" style={{ backgroundColor: '#F8F8F8', paddingTop: '20px' }}>

                <div className="MainHome-services-container-subcontainer1-title" style={{ color: '#384D64', fontWeight: '600' }}>OUR SERVICES</div>
                <h2 className='how-it-works-title'>Most Popular Services</h2>
                <div className="MainHome-services-container-subcontainer1-title-content-des" style={{ textAlign: 'center' }}> Discover our top-rated services designed to meet your needs with quality and care.</div>
            </div>
            <PricingComponent />

            {/* <RecentProjects /> */}
            {/* <CleantoBanner /> */}
            <Footer />
        </>
    )
}

export default MainHome
